import { Badge, Loader } from "@mantine/core";
import type { FC } from "react";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import type { TilesetVersion } from "../types/tileset";

interface StatusIconProps {
  version: TilesetVersion | null;
}

export const StatusIcon: FC<StatusIconProps> = memo(({ version }) => {
  if (!version) {
    return null;
  }

  switch (version.status) {
    case "pending":
      return (
        <>
          <Loader size="xs" color="yellow" />
          <Badge size="sm" variant="light" color="yellow">
            <FormattedMessage defaultMessage="Pending" id="label.tilesetStatus.pending" />
          </Badge>
        </>
      );
    case "processing":
      return (
        <>
          <Loader size="xs" color="orange" />
          <Badge size="sm" variant="light" color="orange">
            <FormattedMessage defaultMessage="Processing" id="label.tilesetStatus.processing" />
          </Badge>
        </>
      );
    case "distribution":
      return (
        <>
          <Loader size="xs" color="orange" />
          <Badge size="sm" variant="light" color="orange">
            <FormattedMessage defaultMessage="Distribution" id="label.tilesetStatus.distributionComplete" />
          </Badge>
        </>
      );
    case "ready":
      return (
        <Badge size="sm" variant="light" color="green">
          <FormattedMessage defaultMessage="Ready" id="label.tilesetStatus.ready" />
        </Badge>
      );
    case "failed":
      return (
        <Badge size="sm" variant="light" color="red">
          <FormattedMessage defaultMessage="Failed" id="label.tilesetStatus.failed" />
        </Badge>
      );
    default:
      return null;
  }
});
